import { useContext } from 'react'
import CardContext from './CardContext'

const useCardContext = () => {
  return useContext(CardContext)
}

export default useCardContext